import { useState } from 'react';

const navItems = [
  { label: '今日 TOP10', href: '#rank' },
  { label: '全网合集', href: '#collection' },
  { label: '话题墙', href: '#topic' },
  { label: '信任说明', href: '#trust' },
  { label: '爆料投稿', href: '#submit' },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 w-full border-b border-background-200/70 bg-background-50/90 backdrop-blur">
      <div className="flex h-16 items-center gap-6 px-4 md:h-[72px] md:px-8">
        <a href="#top" className="flex shrink-0 items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-lg font-bold text-background-50 dark:text-foreground-950">
            热
          </span>
          <span className="font-heading text-xl font-bold tracking-tight text-foreground-950">
            热点黑料
          </span>
        </a>

        <nav className="hidden items-center gap-1 md:flex">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="rounded-md px-3 py-2 text-sm font-medium whitespace-nowrap text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-700"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="ml-auto flex items-center gap-3">
          <span className="hidden items-center gap-2 rounded-full bg-secondary-100 px-3.5 py-1.5 text-xs font-medium text-secondary-900 lg:flex">
            <i className="ri-live-line flex h-3.5 w-3.5 items-center justify-center text-sm text-primary-600" />
            今日已更新 128 条
          </span>
          <a
            href="#rank"
            className="hidden rounded-md bg-primary-500 px-4 py-2 text-sm font-medium whitespace-nowrap text-background-50 transition-colors hover:bg-primary-600 dark:text-foreground-950 md:inline-flex"
          >
            查看今日榜单
          </a>
          <button
            type="button"
            aria-label={open ? '收起菜单' : '展开菜单'}
            onClick={() => setOpen((prev) => !prev)}
            className="flex h-10 w-10 items-center justify-center rounded-md border border-background-200 text-foreground-800 md:hidden"
          >
            <i className={`${open ? 'ri-close-line' : 'ri-menu-line'} flex h-5 w-5 items-center justify-center text-lg`} />
          </button>
        </div>
      </div>

      {open ? (
        <div className="border-t border-background-200/70 bg-background-50 px-4 pb-4 pt-2 md:hidden">
          <nav className="flex flex-col">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-2 py-3 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100 hover:text-primary-700"
              >
                {item.label}
              </a>
            ))}
          </nav>
          <a
            href="#rank"
            onClick={() => setOpen(false)}
            className="mt-2 block rounded-md bg-primary-500 px-4 py-3 text-center text-sm font-medium text-background-50 dark:text-foreground-950"
          >
            查看今日榜单
          </a>
        </div>
      ) : null}
    </header>
  );
}